import React, {useEffect} from 'react';
import './NewAttentionModal.scss';
import {connect} from 'react-redux';
import RoundRectangleModal from '../../../common/components/RoundRectangleModal/RoundRectangleModal';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import {InputErrorMessage} from '../../../common/components/InputErrorMessage/InputErrorMessage';
import actions from '../../../redux/actions';
import {getActualDate} from '../../../utils/util';
import {useFormik} from 'formik';


const NewAttentionModal = ({
    showModal,
    handleClose,
    handleClick,
    queryList,
    branches,
    getBranches,
    userInfo,
}) => {
    useEffect(()=>{
        getBranches();
        // eslint-disable-next-line
    }, []);
    const formik = useFormik({
        initialValues: {
            branchId: userInfo?.branchId,
            date: getActualDate(),
            copayType: 'Sum',
        },
        // validationSchema: validationSchema,
        onSubmit: (values) => {
            console.log(values);
        },
    });

    const modalBody = () => {
        return (
            <form className="eu-form" onSubmit={formik.handleSubmit}>
            <div className='modal-body-container at-dt-modal'>
                <div className='modal-title'>
                    Nueva Atencion
                </div>
                <br/>
                <div className='modal-body-section'>
                <div className="ul-div-form w100">

                        <div className="eu-div-container">

                            <div className="eu-div-input">
                                <text className="eu-text-l eu-f-label">DNI</text>
                                <text className="eu-text-s eu-f-label">CONSULTA</text>
                            </div>
                            <div className="eu-div-input">
                                <input className="eu-input-l" name="dni" value={formik.values.dni}
                                    onChange={formik.handleChange}
                                />
                                <input className="eu-input-s"
                                    name="query" value={formik.values.query} list='queryList'
                                    onChange={formik.handleChange}
                                />
                                <datalist id="queryList">
                                    {queryList &&
                                    queryList.map( (item, i)=>(
                                        <option key={i} value={item} />
                                    ) ) }
                                </datalist>
                            </div>
                            <div className="eu-div-input">
                                <InputErrorMessage formik={formik} name='dni' className='eu-input-l' />
                                <InputErrorMessage formik={formik} name='query' className='eu-input-s' />
                            </div>

                            <div className="eu-div-input">
                                <text className="eu-text-l eu-f-label">FECHA</text>
                                <text className="eu-text-s eu-f-label">SEDE</text>
                            </div>
                            <div className="eu-div-input">
                                <input className="eu-input-l" type="date" name="date" value={formik.values.date}
                                    onChange={formik.handleChange}
                                />
                                <select className="eu-input-s" name="branchId"
                                    value={formik.values.branchId} onChange={formik.handleChange}
                                    disabled={userInfo?.role?.name!=='ADMIN'}
                                >
                                    <option value={null}>NINGUNA</option>
                                    { branches?.map((branch, i)=>(
                                        <option key={i} value={branch.id} title={branch.cuitOrCuil}>{branch.name}</option>
                                    ) )
                                    }
                                </select>
                            </div>
                            <div className="eu-div-input">
                                <InputErrorMessage formik={formik} name='date' className='eu-input-l' />
                                <InputErrorMessage formik={formik} name='branchId' className='eu-input-s' />
                            </div>

                            <div className="eu-div-input">
                                <text className="eu-text-l eu-f-label">COPAGO</text>
                                <text className="eu-text-s eu-f-label"></text>
                            </div>
                            <div className="eu-div-input">
                                <select className="eu-input-l" name="copayType"
                                    value={formik.values.copayType} onChange={formik.handleChange}
                                >
                                    <option value='Covered'>Cubierto</option>
                                    <option value='NotCovered'>No Cubierto</option>
                                    <option value='Sum'>Monto a abonar</option>
                                </select>
                                <input className="eu-input-s" type='number'
                                    name="copayAmmount" value={formik.values.copayAmmount}
                                    onChange={formik.handleChange}
                                    disabled={formik.values.copayType!=='Sum'}
                                />
                            </div>
                            <div className="eu-div-input">
                                <InputErrorMessage formik={formik} name='copayType' className='eu-input-l' />
                                <InputErrorMessage formik={formik} name='copayAmmount' className='eu-input-s' />
                            </div>

                        </div>
                    </div>
                </div>
                <div className='btn-container modal-btn-container at-dt-cent'>
                    <Ebutton classNameButton="eu-btn" type="submit" text="CREAR ATENCION"/>
                </div>
            </div>
            </form>
        );
    };

    return (
        <RoundRectangleModal
            isOpen={showModal}
            handleOnClose={handleClose}
            showCloseIcon={true}
            body={modalBody()}
            className='at-new-mod-cont'
        />
    );
};

const mapStateToProps = (state) => ({
    selectedAffiliate: state.attentions.selectedAffiliate,
    attention: state.attentions.selectedAttention,
    queryList: state.attentions.queryList,
    branches: state.home.branches,
    userInfo: state.login.userInfo,
});

const mapDispatchToProps = (dispatch) => ({
    getBranches: () => dispatch(actions.home.getBranchesRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewAttentionModal);
